import React, { useState, useRef, useEffect } from "react";
import { kbdEvent } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import Float from "./Float";

const SelectBox = React.forwardRef((props, ref) => {
    const {
        width = 100,
        height = 300,
        value = null,
        options = [],
        className = "",
        style = {},
        edit = false,
        placeholder = "",
        onChange = () => { },
        onEnter = null,
        onPageUp = null,
        onPageDown = null,
        onFocus = () => { },
        onBlur = () => { },
        onClick = () => { },
        render = false,
        autofocus = false,
        dataId = "",
        opened = false,
        allowKeys = false,
        keyfield = "key",
        autocomplete = false,
        small = false
    } = props;



    const [isOpen, setIsOpen] = useState(opened);
    const [isFocused, setIsFocused] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const dropdownRef = useRef(null);

    const [highlightIndex, setHighlightIndex] = useState(() => {
        const idx = options.findIndex(o => o.value === value);
        return idx >= 0 ? idx : 0;
    });

    const filteredOptions = autocomplete ? options.filter(opt => opt.label.toLowerCase().includes(inputValue.toLowerCase())) : options;



    useEffect(() => {
        const idx = options.findIndex(o => o.value === value);
        setHighlightIndex(idx >= 0 ? idx : 0);
    }, [value, options]);

    useEffect(() => {
        if (autocomplete) {
            const opt = options.find(o => o.value === value);
            setInputValue(opt?.label || "");
        }
    }, [value, options, autocomplete]);


    let _class = edit ? "ui-input edit" : "ui-input";
    if (small) {
        _class = _class + " small"
    }
    if (className) _class += ` ${className}`;


    if (width) style.width = `${width}px`;


    const selectedOption = options.find(o => o.value === value);

    const handleSelect = (opt) => {
        if (autocomplete) {
            setInputValue(opt.label);
            onChange(opt.label);
        } else {
            onChange(opt.value);
        }

        setTimeout(() => {
            setIsOpen(false);
        }, 10)

    };

    useEffect(() => {
        if (isFocused) {
            setIsOpen(true)
        }
    }, [isFocused])

    useEffect(() => {
        if (highlightIndex >= filteredOptions.length) {
            setHighlightIndex(0);
        }
    }, [filteredOptions]);

    const handleKeyDown = (e) => {


        if (allowKeys && isOpen && !autocomplete) {
            if (/^[a-zA-Z-0-9]$/.test(e.key)) {
                const _f = options.find(item => {
                    let _fld = item?.[keyfield]?.key || item?.[keyfield];
                    return _fld.toLowerCase() === e.key.toLowerCase()
                });
                if (_f) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSelect(_f);
                }
            }
        }

        if (e.key === "ArrowDown" && isOpen) {
            e.stopPropagation();
            e.preventDefault();

            if ((highlightIndex + 1) > (filteredOptions.length - 1)) {
                kbdEvent(KBD.TAB);
            } else {
                setHighlightIndex(i => i + 1);
            }
            return;
        }

        if (e.key === "ArrowLeft" && isOpen) {
            e.preventDefault();
            e.stopPropagation();
            kbdEvent(KBD.SHIFT_TAB);
        }

        if (e.key === "Escape" && isOpen) {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(false)
        }

        if (e.key === "ArrowRight" && isOpen) {
            e.preventDefault();
            e.stopPropagation();
            kbdEvent(KBD.TAB);
        }

        if (e.key === "ArrowUp" && isOpen) {
            e.stopPropagation();
            e.preventDefault();
            if ((highlightIndex - 1) < 0) {
                kbdEvent(KBD.SHIFT_TAB);
            } else {
                setHighlightIndex(i => i - 1);
            }

            return;
        }

        if (e.key === "Enter" && !isOpen) {
            e.stopPropagation();
            e.preventDefault();
            if (onEnter) {
                onEnter(value, e);
            }
        }

        if (e.key === "Enter" && isOpen) {
            const opt = filteredOptions[highlightIndex];


            if (isOpen && autocomplete) {
                // onEnter?.(inputValue, e);
            } else if (isOpen && opt) {
                if (opt) handleSelect(opt);
                // if (onEnter) onEnter(value, e);
            }



            setIsOpen(false);
            return;
        }



        if (e.key === "PageUp" && onPageUp) {
            onPageUp(value);
        }

        if (e.key === "PageDown" && onPageDown) {
            onPageDown(value, e);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        setIsOpen(true);
        onFocus();
    };

    const handleBlur = () => {
        setIsFocused(false);
        setTimeout(() => setIsOpen(false), 100);
        onBlur(value);
    };

    useEffect(() => {
        if (!isOpen) return;
        const active = dropdownRef.current?.querySelector(`.ui-select-option[data-index="${highlightIndex}"]`);
        active?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, [highlightIndex, isOpen]);


    let _input_class = edit ? "ui-input edit" : "ui-input";
    if (small) {
        _input_class = _input_class + " small";
    }
    if (edit) {
        return (
            <div
                data-id={dataId}
                className={_class}
                style={{ ...style, "textOverflow": (autocomplete) ? "unset" : "ellipsis" }}
                tabIndex={(autocomplete) ? undefined : 0}
                ref={(!autocomplete) ? ref : null}
                onKeyDown={handleKeyDown}
                onFocus={handleFocus}
                onBlur={handleBlur}

                onClick={() => {
                    if (!isOpen && isFocused) {
                        setIsOpen(true);
                    }
                    if (!isFocused) {
                        onClick();

                    }

                }}
            >

                {(autocomplete &&
                    <input

                        style={{ "marginLeft": "-5px", "width": width + "px" }}
                        className={_input_class}
                        value={inputValue}
                        placeholder={placeholder}

                        ref={(autocomplete) ? ref : null}
                        onChange={(e) => {

                            setInputValue(e.target.value);
                            setHighlightIndex(0);
                            setIsOpen(true);

                        }}

                        onKeyDown={handleKeyDown}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                )}

                {(!autocomplete &&
                    <div style={{ "opacity": (selectedOption?.label) ? "1" : "0.6", userSelect: "none" }} className="ui-select-display">
                        {selectedOption?.label || placeholder}&nbsp;
                    </div>
                )}



                {isOpen && isFocused && (
                    <div
                        ref={dropdownRef}
                        style={{
                            width: width + 12 + "px",
                            maxHeight: height + "px",
                            overflowY: "auto",
                            overflowX: "hidden",
                            zIndex: 1,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)"


                        }} className={(small) ? "ui-select-dropdown" : "ui-select-dropdown small"}>
                        {filteredOptions.map((opt, index) => (
                            <div
                                key={opt.value}
                                data-index={index}
                                style={{ "color": (opt?.color) ? opt.color : "inherit" }}
                                className={`ui-select-option ${filteredOptions[highlightIndex]?.value === opt.value ? "active" : ""}`}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => handleSelect(opt)}
                            >
                                <Float style={{ "alignContent": "center" }}>
                                    <span style={{ "pointerEvents": "none" }}>{opt.label}</span>
                                    <div style={{ "textAlign": "right", "fontSize": "12px" }}>
                                        {(allowKeys && !autocomplete && <kbd className="small" style={{ "opacity": "0.7", "fontWeight": "600" }}>&nbsp;{opt.value}&nbsp;</kbd>)}
                                    </div>
                                </Float>

                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div
            data-id={dataId}
            className={_class}
            style={style}
            onClick={onClick}
        >
            {render !== false
                ? render
                : selectedOption?.label || (
                    <em style={{ opacity: 0.5 }}>{placeholder}</em>
                )
            }
        </div>
    );
});

export default SelectBox;